import { useTranslation } from '@web_opxp/features';
import React from 'react';
import { connect } from 'react-redux';
import { IState } from '../../store/state';
import * as Selectors from '../selectors';
import { IAchievement } from '../types';
import AchievementBadge from './AchievementBadge';
import AchievementsHint from './AchievementsHint';
import './AchievementsView.scss';

export interface IAchievementsViewProps {
  achievements: IAchievement[];
}

/**
 * this is a panel shown below the post-exercise view
 */
export const AchievementsViewFC: React.FC<IAchievementsViewProps> = ({ achievements }) => {
  const { t } = useTranslation();

  if (!achievements.length) {
    return null;
  }
  const title = t('Achievements.List.Title');
  const badges = achievements.map((achievement) => (
    <AchievementBadge
      key={`${achievement.type}${achievement.subType}${achievement.workoutId}`}
      type={achievement.type}
      subType={achievement.subType}
    />
  ));
  const viewSize = achievements.length > 3 ? 'big' : 'small';
  const viewClasses = `achievements-view ${viewSize}`;
  return (
    <div className={viewClasses}>
      <div className="panel">
        <h2 className="achievements-title">
          {title}
          <AchievementsHint />
        </h2>
        <div className="achievement-badges-list">{badges}</div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: IState) => {
  const achievements = Selectors.getCurrentAchievements(state);
  return {
    achievements,
  };
};

const AchievementsView = connect(mapStateToProps)(AchievementsViewFC);
AchievementsView.displayName = 'AchievementsView';
export default AchievementsView;
